import React from "react";

const ColumnDivider = ({ onMouseDown }) => {
  return (
    <div
      onMouseDown={onMouseDown}
      style={{
        width: "12px",
        cursor: "col-resize",
        position: "relative",
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center",
      }}
    >
      {/* actual vertical line */}
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "5px",
          backgroundColor: "#a3a3a3",
        }}
      />
      {/* Grab handle */}
      <div
        style={{
          width: "12px",
          height: "25px",
          backgroundColor: "#111827",
          borderRadius: "4px",
          border: "2px solid white",
          position: "absolute",
          top: "25%",
          transform: "translateY(-50%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "2px",
          pointerEvents: "none", // so dragging still works
        }}
      >
        {/* Left triangle */}
        <div
          style={{
            width: 0,
            height: 0,
            borderTop: "5px solid transparent",
            borderBottom: "5px solid transparent",
            borderRight: "4px solid white",
          }}
        />

        {/* Right triangle */}
        <div
          style={{
            width: 0,
            height: 0,
            borderTop: "5px solid transparent",
            borderBottom: "5px solid transparent",
            borderLeft: "4px solid white",
          }}
        />
      </div>
    </div>
  );
};

export default ColumnDivider;
